import StudyInformation from './StudyInformation';

export default StudyInformation;
